import styled, { keyframes } from "styled-components";

const authMapScroll = keyframes`
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    transform: translate3d(-50%, 0, 0);
  }
`;

export const AuthLayoutMediaSurface = styled.div.attrs({
  className: "brand-shell flex min-h-screen overflow-hidden",
})``;

export const AuthLayoutSectionBody = styled.div.attrs({
  className:
    "flex w-full items-center justify-center px-4 py-6 sm:px-6 sm:py-8 md:w-[48%] md:px-10",
})``;

export const AuthLayoutMediaSurfaceSecondary = styled.div.attrs({
  className: "brand-panel w-full max-w-xl overflow-hidden p-0",
})``;

export const AuthLayoutGridLayout = styled.div.attrs({
  className: "grid gap-6 p-5 sm:p-7 md:p-8",
})``;

export const AuthLayoutSection = styled.div.attrs({
  className: "relative hidden overflow-hidden md:flex md:w-[52%]",
})`
  background: var(--brand-shell-background);
`;

export const AuthLayoutMapFrame = styled.div.attrs({
  className: "pointer-events-none absolute inset-0 overflow-hidden",
})`
  isolation: isolate;
`;

export const AuthLayoutMapStage = styled.div.attrs({
  className: "absolute inset-0 overflow-hidden",
})`
  contain: paint;
  transform: translateZ(0);

  -webkit-mask-image: linear-gradient(
    to right,
    transparent 0%,
    rgba(0, 0, 0, 0.45) 4%,
    #000 9%,
    #000 100%
  );
  mask-image: linear-gradient(
    to right,
    transparent 0%,
    rgba(0, 0, 0, 0.45) 4%,
    #000 9%,
    #000 100%
  );
`;

export const AuthLayoutMapTrack = styled.div.attrs({
  className: "absolute inset-y-0 left-0 flex h-full items-stretch",
})`
  width: max-content;
  animation: ${authMapScroll} 64s linear infinite;
  backface-visibility: hidden;
  transform: translateZ(0);
  will-change: transform;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    transform: translate3d(-12%, 0, 0);
  }
`;

export const AuthLayoutMapTile = styled.div.attrs({
  className: "relative h-full shrink-0",
})`
  aspect-ratio: 2.48 / 1;
`;

export const AuthLayoutIllustrationImage = styled.img.attrs({
  className: "absolute inset-0 h-full w-full",
})`
  backface-visibility: hidden;
  opacity: 0.18;

  @media (prefers-reduced-motion: reduce) {
    opacity: 0.16;
  }
`;

export const AuthLayoutSectionSecondary = styled.div.attrs({
  className: "absolute inset-0",
})`
  background: rgba(15, 20, 27, 0.54);
`;

export const AuthLayoutSectionTertiary = styled.div.attrs({
  className: "relative z-10 flex h-full w-full flex-col justify-between p-8 text-white lg:p-10",
})``;

export const AuthLayoutInfoRow = styled.div.attrs({
  className: "flex items-center gap-4",
})``;

export const AuthLayoutIllustrationImageSecondary = styled.img.attrs({
  className: "h-14 w-14 object-contain",
})``;

export const AuthLayoutEyebrowText = styled.p.attrs({
  className: "font-anonymous text-xs uppercase tracking-[0.28em] text-white/82",
})``;

export const AuthLayoutTextBlock = styled.p.attrs({
  className: "mt-1 text-sm text-white/70",
})``;

export const AuthLayoutPageHeading = styled.h1.attrs({
  className: "mt-4 max-w-md text-4xl leading-tight text-white lg:text-5xl",
})``;

export const AuthLayoutBodyText = styled.p.attrs({
  className: "mt-4 max-w-lg text-[13px] leading-6 text-white/82",
})``;

export const AuthLayoutGridLayoutSecondary = styled.div.attrs({
  className: "grid max-w-[620px] gap-3 lg:grid-cols-3",
})``;

export const AuthLayoutPanelCard = styled.div.attrs({
  className:
    "rounded-[24px] border border-[rgba(255,255,255,0.04)] bg-[rgba(255,255,255,0.035)] px-4 py-4 backdrop-blur-sm",
})`
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
  min-height: 116px;
`;

export const AuthLayoutPanelEyebrow = styled.p.attrs({
  className: "font-anonymous text-xs uppercase tracking-[0.24em] text-white/72",
})``;

export const AuthLayoutTextBlockSecondary = styled.p.attrs({
  className: "mt-3 text-[13px] leading-6 text-white/86",
})``;
